import { stringToArrayBuffer } from './string-to-array-buffer';

export function encryptDataWithPublicKey(data, key) {
  data = stringToArrayBuffer(data);
  return window.crypto.subtle.encrypt({ name: 'RSA-OAEP' }, key, data);
}
